import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SectionIntro } from '#src/app/pages/about/shared/components';

import { MockChatCard } from './components/MockChatCard';

export const CampaignCopilot: React.FC<EmptyProps> = () => {
	return (
		<section className="container pb-16 md:pb-32">
			<div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-18" data-qa="vision-copilot-grid">
				<SectionIntro
					eyebrow={translationKey('corgi.vision_page.copilot.eyebrow')}
					heading={translationKey('corgi.vision_page.copilot.heading')}
					body={translationKey('corgi.vision_page.copilot.body')}
					align="start"
				/>
				<MockChatCard />
			</div>
		</section>
	);
};
